/**
 * @module
 */
import {UserProfile} from '../profile/profile.js';
import {TwoFactorConfig} from '../../auth/two-factor.js';
import {UserRename} from './rename.js';
import {PasswordChange} from './password-change.js';
import {MailAddressChange} from './mail-address-change.js';
import {mailingConfigController} from './mailing-config.js';
import {clickDelete} from './delete.js';
import {clickDeactivate} from './deactivate.js';
import {CookieBar} from './cookie-bar.js';
import {AgeVerification} from '../age-verification.js';
import {make} from '../../core/service/env.js';

class UserSettings {
  profile = make(UserProfile);

  mail = {
    change: new MailAddressChange(),
    config: mailingConfigController,
  };

  auth = {
    rename: new UserRename(),
    password: new PasswordChange(),
    twoFactor: new TwoFactorConfig(),
  };

  delete = clickDelete;
  deactivate = clickDeactivate;
  cookie = new CookieBar();
  avs = make(AgeVerification);
}

export {UserSettings};
